module.exports = "data:image/webp;base64,UklGRqwAAABXRUJQVlA4IKAAAAAQBACdASoZABkAPpE8mEiloyIhKA1QsBIJZT1vHWDcACQPNuFXcuRKgAD+8o5BUJILjFIVwObLC7bi7k/S99a8/ci99ILwy26vTfTA9OQq0L2JaugUpfjB0MAqEnCV7I+wY5NlDJ6+Dub9Pt59+OVD2reRXSRJnuinpdhhKzPQ3y8EEKmVG7xo5B/+ei8l/m/2pgDd4jiou28PhDLUAAAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/pink.webp
// module id = oyTj
// module chunks = 14